import { createSlice } from "@reduxjs/toolkit";

export const UserRoleReducer = createSlice({
    name: "UserRoleReducer",
    initialState: {
        sidebarData: []
    },
    reducers: {
        setUserRole: (state, action) => {
            const modules = action.payload.modules.map((module) => {
                const filteredSubModules = module.subModule?.filter(sub => sub.subModuleId !== "S0021") || [];

                return {
                    ...module,
                    subModule: filteredSubModules
                };
            });
            state.sidebarData = modules;
        },
    }
});
export const {setUserRole} = UserRoleReducer.actions;

export default UserRoleReducer.reducer;